import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "./style.scss"

class Dot extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    focus: PropTypes.func.isRequired,
    blur: PropTypes.func.isRequired,
    focused: PropTypes.string,
    color: PropTypes.string.isRequired,
    y: PropTypes.number,
  }

  onEnter = () => {
    const { id, focus } = this.props
    focus(id)
  }

  onLeave = () => {
    const { blur } = this.props
    blur()
  }

  render() {
    const { color, y, focused, id } = this.props
    if (!Number.isFinite(y)) {
      return null
    }

    return <g
      onMouseEnter={this.onEnter}
      onMouseLeave={this.onLeave}
      transform={`translate(0,${y})`}
      className={classNames(
        "dot focus-enabled",
        focused && focused === id && "visible",
        focused && focused !== id && "hidden",
      )}
    >
      <circle r="4" cx="0" cy="0" style={{ fill: color }} />
      <circle r="8" cx="0" cy="0" style={{ fill: color }} className="selected" />
    </g>
  }
}

export default Dot
